import { object, string, number } from 'yup';

export const receiveValidation = () => object().shape({});

export const stockValidation = (maxMissing) =>
  object().shape({
    missingQuantity: number().when(['productNotMissing'], {
      is: (productNotMissing) => !productNotMissing,
      then: () =>
        number()
          .min(1, 'Minimum 1 missing')
          .max(maxMissing, `Max ${maxMissing} missing`)
          .required('Missing Quantity is required'),
      otherwise: () => number().nullable()
    }),
    locationId: string().required('Location is required')
  });
